import { enqueueSnackbar, UploadFile, DownloadFile } from 'actions';

import { ReportSmallCellsImpactRequest } from '../requests/ReportSmallCellsImpactRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const ReportSmallCellsImpactExport = (values, userId) => async (dispatch) => {
	await ReportSmallCellsImpactRequest(values, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
